import { render, staticRenderFns } from "./OrderItemInput.vue?vue&type=template&id=312720f2"
import script from "./OrderItemInput.vue?vue&type=script&lang=js"
export * from "./OrderItemInput.vue?vue&type=script&lang=js"
import style0 from "./OrderItemInput.vue?vue&type=style&index=0&id=312720f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardActions,
  VContainer,
  VDialog,
  VFlex,
  VIcon,
  VLayout,
  VSpacer,
  VTextarea,
})
